module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/cloud/sorority-cloud-01-large-160400982edfbd76bf6a7a2df938b56b.jpg";